import { isDevEnvironment } from "../../env/runtimeEnv";

async function readErrorMessage(response: Response): Promise<string> {
  const text = await response.text();
  if (!text.trim()) {
    return `Request failed (${response.status}).`;
  }
  try {
    const data = JSON.parse(text) as { error?: string; message?: string };
    return data.error || data.message || `Request failed (${response.status}).`;
  } catch {
    return text.length <= 400 ? text : `Request failed (${response.status}).`;
  }
}

async function readJsonBody<T>(response: Response): Promise<T> {
  const text = await response.text();
  if (!text.trim()) {
    return {} as T;
  }
  try {
    return JSON.parse(text) as T;
  } catch {
    throw new Error("Invalid response from server.");
  }
}

/**
 * Sends a magic link email via HTTPS endpoint
 * @param email - User's email address
 * @returns Promise with success result or throws error
 */
export async function sendMagicLinkEmail(email: string): Promise<any> {
  const functionUrl = isDevEnvironment
    ? "https://sendmagiclinkhttps-cutfmzstga-ew.a.run.app"
    : "https://sendmagiclinkhttps-sq7op6itlq-ew.a.run.app";

  console.log("email is here -> " + email);

  const response = await fetch(functionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email,
      origin: window.location.origin,
      continue: "/home",
    }),
  });

  if (!response.ok) {
    const message = await readErrorMessage(response);
    throw new Error(message);
  }

  const result = await readJsonBody(response);

  window.localStorage.setItem("emailForSignIn", email);

  return result;
}
